import React from 'react';
import './SkeletonLoader.css';

interface SkeletonLoaderProps {
  type?: 'card' | 'chart' | 'line' | 'text' | 'avatar';
  count?: number;
  width?: string | number;
  height?: string | number;
  circle?: boolean;
  className?: string;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  type = 'card',
  count = 1,
  width = '100%',
  height = '20px',
  circle = false,
  className = '',
}) => {
  const getSkeletonClass = () => {
    switch (type) {
      case 'card':
        return 'skeleton-card';
      case 'chart':
        return 'skeleton-chart';
      case 'text':
        return 'skeleton-text';
      case 'avatar':
        return 'skeleton-avatar';
      default:
        return 'skeleton-base';
    }
  };

  const skeletons = Array.from({ length: count });

  return (
    <div className={`skeleton-loader ${className}`}>
      {skeletons.map((_, index) => (
        <div
          key={index}
          className={`skeleton ${getSkeletonClass()} ${circle ? 'skeleton-circle' : ''}`}
          style={{
            width: typeof width === 'number' ? `${width}px` : width,
            height: typeof height === 'number' ? `${height}px` : height,
          }}
        />
      ))}
    </div>
  );
};

export default SkeletonLoader;
